var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.814,
    height: 32,
    viewBox: "0 0 17.814 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-glass-cup-6204253",
    transform: "translate(-30.862 -18.143)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "Layer_20",
    "data-name": "Layer 20",
    transform: "translate(30.862 18.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M47.976,18.143H31.56a.7.7,0,0,0-.692.791c.024.178,2.395,17.93,1.868,30.482a.7.7,0,0,0,.7.727H46.1a.7.7,0,0,0,.7-.727c-.526-12.549,1.844-30.3,1.868-30.479a.7.7,0,0,0-.692-.791ZM45.332,44.669H34.2c-.047-6.748-.658-14.087-1.183-19.229a11.4,11.4,0,0,1,6.215.784,16.629,16.629,0,0,0,6.22,1.588c.276,0,.552-.014.831-.04C45.827,32.669,45.374,38.886,45.332,44.669Zm1.851-25.13c-.15,1.193-.447,3.656-.76,6.813-1.793.233-3.519-.145-6.661-1.423a12.787,12.787,0,0,0-6.887-.882c-.219-2.045-.411-3.624-.522-4.509ZM34.158,48.744c.029-.873.043-1.768.047-2.68H45.33c0,.91.019,1.807.047,2.68Z",
    transform: "translate(-30.862 -18.143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassCup);
export default __webpack_public_path__ + "static/media/glassCup.270e7861ee2cdf121b020eccaa2e0a20.svg";
export { ForwardRef as ReactComponent };